import React, { Component } from 'react';

class Empty extends Component {
  render() {
    return (
      <div />
    );
  }
}

export default Empty;
